export default "__VITE_ASSET__CHmM8bwU__"